import SERVICES_INFO from './services-info';
import { kebabCase } from 'lodash/string';

const HEADER_MENU = [
  {
    text: 'Services',
    icon: 'keyboard_arrow_down',
    link: '/services',
    children: Object.values(SERVICES_INFO).map(service => ({
      text: service.name,
      link: `/services-${kebabCase(service.name.toLowerCase())}`,
    })),
  },
  {
    text: 'Company',
    link: '/company',
  },
  {
    text: 'Clients & Testimonials',
    link: '/clients-and-testimonials'
  },
  {
    text: 'Blog',
    link: '/blog',
  },
];

export default HEADER_MENU;
